import { render } from "./VolumeControl.vue?vue&type=template&id=8aa015a8"
import script from "./VolumeControl.vue?vue&type=script&lang=js"
export * from "./VolumeControl.vue?vue&type=script&lang=js"

import "./VolumeControl.vue?vue&type=style&index=0&id=8aa015a8&lang=scss"
script.render = render

export default script